<template lang="pug">
  // Topbar
  nav.navbar.navbar-expand.navbar-light.topbar.mb-4.static-top.shadow
    // Sidebar Toggle (Topbar)
    button#sidebarToggleTop.btn.btn-link.d-md-none.rounded-circle.mr-3(v-on:click="toggleMobileNav")
      i.fa.fa-bars
    // Topbar Search
    //- form.d-none.d-sm-inline-block.form-inline.mr-auto.ml-md-3.my-2.my-md-0.mw-100.navbar-search
      .input-group
        input.form-control.bg-light.border-0.small(type='text', placeholder='Search for...', aria-label='Search')
        .input-group-append
          button.btn(type='button')
            i.fas.fa-search.fa-sm
    // Topbar Navbar
    ul.navbar-nav.ml-auto
      li.nav-item
        a.mailto.nav-link(target="_blank" :href="mailto") Need Help?
      // Nav Item - Search Dropdown (Visible Only XS)
      //- li.nav-item.dropdown.no-arrow.d-sm-none
        a(href='', role='button', data-toggle='dropdown', aria-haspopup='true', aria-expanded='false')
          i.fas.fa-search.fa-fw
        // Dropdown - Messages
        .dropdown-menu.dropdown-menu-right.p-3.shadow.animated--grow-in(aria-labelledby='searchDropdown')
          form.form-inline.mr-auto.w-100.navbar-search
            .input-group
              input.form-control.bg-light.border-0.small(type='text', placeholder='Search for...', aria-label='Search', aria-describedby='basic-addon2')
              .input-group-append
                button.btn.btn-primary(type='button')
                  i.fas.fa-search.fa-sm
      // Nav Item - Alerts
      //- li.nav-item.dropdown.no-arrow.mx-1(v-on:click="dropdownOpen('notificationDropdown')")
        #alertsDropdown.nav-link
          i.fas.fa-bell.fa-fw
          // Counter - Alerts
          span.badge.badge-danger.badge-counter 3+
        // Dropdown - Alerts
      //- DashboardNavNotifications(
          v-if="notificationDropdown"
        )       
      // Nav Item - Messages
      //- li.nav-item.dropdown.no-arrow.mx-1
        a#messagesDropdown.nav-link
          i.fas.fa-envelope.fa-fw
          // Counter - Messages
          span.badge.badge-danger.badge-counter 7
        // Dropdown - Messages
        //- .dropdown-list.dropdown-menu.dropdown-menu-right.shadow.animated--grow-in(aria-labelledby='messagesDropdown')
          h6.dropdown-header
            | Message Center
          a.dropdown-item.d-flex.align-items-center(href='')
            .dropdown-list-image.mr-3
              img.rounded-circle(src='https://source.unsplash.com/fn_BT9fwg_E/60x60', alt='')
              .status-indicator.bg-success
            .font-weight-bold
              .text-truncate Hi there! I am wondering if you can help me with a problem I've been having.
              .small.text-gray-500 Emily Fowler · 58m
          a.dropdown-item.d-flex.align-items-center(href='')
            .dropdown-list-image.mr-3
              img.rounded-circle(src='https://source.unsplash.com/AU4VPcFN4LE/60x60', alt='')
              .status-indicator
            div
              .text-truncate
                | I have the photos that you ordered last month, how would you like them sent to you?
              .small.text-gray-500 Jae Chun · 1d
          a.dropdown-item.d-flex.align-items-center(href='')
            .dropdown-list-image.mr-3
              img.rounded-circle(src='https://source.unsplash.com/CS2uCrpNzJY/60x60', alt='')
              .status-indicator.bg-warning
            div
              .text-truncate
                | Last month's report looks great, I am very happy with the progress so far, keep up the good work!
              .small.text-gray-500 Morgan Alvarez · 2d
          a.dropdown-item.d-flex.align-items-center(href='')
            .dropdown-list-image.mr-3
              img.rounded-circle(src='https://source.unsplash.com/Mv9hjnEUHR4/60x60', alt='')
              .status-indicator.bg-success
            div
              .text-truncate
                | Am I a good boy? The reason I ask is because someone told me that people say this to all dogs, even if they aren't good...
              .small.text-gray-500 Chicken the Dog · 2w
          a.dropdown-item.text-center.small.text-gray-500(href='') Read More Messages
      .topbar-divider.d-none.d-sm-block
      // Nav Item - User Information
      li.nav-item.dropdown.no-arrow
        a#userDropdown.nav-link.dropdown-toggle(v-on:click="dropdownOpen('profileDropdown')")
          span.mr-2.d-none.d-lg-inline.text-gray-600.small.text-right {{fullname}} <br> {{email}}
          img.img-profile(src='../assets/img/rp-user.png')
        // Dropdown - User Information
        .dropdown-menu.dropdown-menu-right.shadow.animated--grow-in(v-if="profileDropdown")         
          router-link.dropdown-item(to='/dashboard/userProfile' v-on:click.native="dropdownClose")
            i.fas.fa-user.fa-sm.fa-fw.mr-2.text-gray-400()
            |                   User Profile
          router-link.dropdown-item(to='/dashboard/billing' v-on:click.native="dropdownClose")
            i.fas.fa-file-invoice-dollar.fa-sm.fa-fw.mr-2.text-gray-400
            |                   Billing
          router-link.dropdown-item(to='/dashboard/plans' v-on:click.native="dropdownClose")
            i.fas.fa-list.fa-sm.fa-fw.mr-2.text-gray-400
            |                   Plans
          .dropdown-divider
          router-link.dropdown-item(to="/logout" v-on:click.native="dropdownClose")
            i.fas.fa-sign-out-alt.fa-sm.fa-fw.mr-2.text-gray-400
            | Logout
    .bg(v-if="bg" v-on:click="dropdownClose")
    .mobileNavBg(v-bind:class="{active:mobileNavOpen}" v-on:click="toggleMobileNav")
</template>

<script>
import DashboardNavNotifications from '@/components/DashboardNavNotifications';
import { mapActions, mapState } from "vuex";
export default {
  name: 'DashboardNav',
  props: {
    msg: String
  },
  components:{
    DashboardNavNotifications
  },
  data:function(){
    return{
      notificationDropdown:false,
      profileDropdown:false,
      bg:false,
      mailto:``,
    }
  },
  
  computed:{ 
    ...mapState(['mobileNavOpen','email', 'fullname']),
    
  },  
  methods:{
    ...mapActions(['updateUser', 'toggleMobileNav']),
    

    dropdownClose(){
      this.notificationDropdown = false;
      this.profileDropdown = false;
      this.bg = false;
    },
    dropdownOpen(el){
      this[el] = !this[el];
      this.bg = !this.bg;
    }
  },
  created(){
    // this.updateUser()
    this.mailto =`https://returnpostage.com/contact?mailFrom=` + this.email;
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.topbar.navbar-light .navbar-nav .nav-item .nav-link{
  color:#172b4d;

}
.mailto{
  a{color:#172b4d;}
}
.fa-bars{
  color:#172b4d;
}
.navbar{
  background:mintcream;
}
.dropdown-menu{
  display:block;
  cursor: pointer;
}
.bg{
  position:fixed;
  width:100%;
  height:100vh;
  left:0;
  top:0;
  z-index: 1;
}
@media all and (max-width:768px ) {
    
    .mobileNavBg{
      width:100%;
      height:100vh;
      position: fixed;
      top:0;
      left:0;
      display: none;
      // background:pink;
      z-index:1;
    }
    .mobileNavBg.active{
      display:block;
    }
  }
</style>
